import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { getAllPosts } from '../data/blogPosts';

const BlogPage = () => {
  const posts = getAllPosts();

  return (
    <div className="min-h-screen flex flex-col">
      <Helmet>
        <title>Equipment Leasing & Financing Blog | EquipEASE Lease Co.</title>
        <meta name="description" content="Expert advice on equipment leasing and financing for Canadian businesses. Learn about tax benefits, financing options, industry guides, and tips for approval." />
        <link rel="canonical" href="https://equipease.ca/blog" />
      </Helmet>
      
      <Header />
      
      <section className="flex-1 py-20 bg-gray-50">
        <div className="container mx-auto px-4">
          <div className="max-w-6xl mx-auto">
            {/* Page Header */}
            <div className="text-center mb-16">
              <h1 className="text-4xl md:text-5xl font-bold mb-4 text-[#333333]">Equipment Financing Blog</h1>
              <div className="w-20 h-1 bg-[#FF6600] mx-auto mb-6"></div>
              <p className="text-xl text-[#4A4A4A]">
                Expert insights, tips, and guides for Canadian businesses
              </p>
            </div>

            {/* Blog Posts Grid */}
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
              {posts.map((post) => (
                <Link
                  key={post.id}
                  to={`/blog/${post.slug}`}
                  className="bg-white rounded-lg shadow-md hover:shadow-xl transition-shadow overflow-hidden group"
                >
                  <div className="relative h-48 overflow-hidden">
                    <img
                      src={post.image}
                      alt={post.title}
                      className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                    />
                    <div className="absolute top-4 left-4">
                      <span className="bg-[#FF6600] text-white px-3 py-1 rounded-full text-sm font-semibold">
                        {post.category}
                      </span>
                    </div>
                  </div>
                  
                  <div className="p-6">
                    <div className="text-sm text-[#4A4A4A] mb-2">
                      {new Date(post.date).toLocaleDateString('en-CA', {
                        year: 'numeric',
                        month: 'long',
                        day: 'numeric'
                      })}
                    </div>
                    
                    <h2 className="text-xl font-bold text-[#333333] mb-3 group-hover:text-[#FF6600] transition-colors">
                      {post.title}
                    </h2>
                    
                    <p className="text-[#4A4A4A] mb-4 line-clamp-3">
                      {post.excerpt}
                    </p>
                    
                    <div className="flex flex-wrap gap-2 mb-4">
                      {post.tags.slice(0, 3).map((tag, index) => (
                        <span
                          key={index}
                          className="text-xs bg-gray-100 text-[#4A4A4A] px-2 py-1 rounded"
                        >
                          {tag}
                        </span>
                      ))}
                    </div>
                    
                    <div className="text-[#FF6600] font-semibold flex items-center">
                      Read More
                      <svg className="w-4 h-4 ml-2 group-hover:translate-x-1 transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                      </svg>
                    </div>
                  </div>
                </Link>
              ))}
            </div>

            {/* CTA Section */}
            <div className="mt-16 bg-gradient-to-r from-[#FF6600] to-[#FF9933] rounded-lg p-12 text-center text-white">
              <h2 className="text-3xl font-bold mb-4">Ready to Finance Your Equipment?</h2>
              <p className="text-xl mb-8">Get a personalized quote in minutes. Competitive rates and flexible terms for Canadian businesses.</p>
              <div className="flex flex-col sm:flex-row gap-4 justify-center">
                <a
                  href="tel:1-844-250-3273"
                  className="bg-white text-[#FF6600] px-8 py-4 rounded-lg font-semibold text-lg hover:bg-gray-100 transition-colors inline-block"
                >
                  Call 1-844-250-EASE
                </a>
                <Link
                  to="/#ready-to-apply"
                  className="bg-[#4A4A4A] hover:bg-[#333333] text-white px-8 py-4 rounded-lg font-semibold text-lg transition-colors inline-block"
                >
                  Apply Online Now
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
      
      <Footer />
    </div>
  );
};

export default BlogPage;
